// Live proof progress published outside React state. The proving-key download
// fires progress many times a second; routing each tick through the large dapp
// component's state re-rendered the whole tree and froze the page mid-download.
// A tiny component subscribes here instead, so only that banner re-renders.
import type { ProofProgress } from "./prover";

type Listener = () => void;

let current: ProofProgress | null = null;
const listeners = new Set<Listener>();

export function setProvingProgress(progress: ProofProgress | null): void {
  current = progress;
  for (const listener of listeners) listener();
}

export function getProvingProgress(): ProofProgress | null {
  return current;
}

export function subscribeProvingProgress(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
